import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Image from 'components/Image';

export default function ModalContent({
  image,
  message,
  onClick,
}) {
  return (
    <Fragment>
      <div className="media">
        <div className="media__left">
          <Image
            icon={image}
          />
        </div>
        <div className="media__body" dangerouslySetInnerHTML={{ __html: message }} />
      </div>
      <div className="buttons">
        <button type="button" className="button button--primary" onClick={onClick}>
          Continue
        </button>
      </div>
    </Fragment>
  );
}

ModalContent.displayName = 'ModalContent';

ModalContent.propTypes = {
  image: PropTypes.string,
  message: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ModalContent.defaultProps = {
  image: undefined,
  message: undefined,
};